function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { WDHComponent } from "../../../../wdh-foundation/wdh";
var Header = /*#__PURE__*/function (_WDHComponent) {
  /**
   * The header component for the Audika Group theme
   *
   * Expected component setup:
   *
   * Image                Data: /sitecore/content/Audika/main/Data/Images/Image - logo    Style variation: Header logo link
   * Link                 Data: /sitecore/content/Audika/main/Data/Links/HashLink         Style variation: Header burger menu
   * Search Field Spot
   * Link                 Data: /sitecore/content/Audika/main/Data/Links/Close nav Link   Style variation: Header burger menu open
   * Navigation Menu      Bottom Navigation Level: 1
   *
   * Expected markup:
   *
   * <div id="#header">
   *     <div class="component image header-logo"></div>
   *     <div class="component link burger-menu"></div>
   *     <div class="component search-field-spot"></div>
   *     <div class="component link burger-menu-open"></div>
   *     <div class="component navigation"></div>
   * </div>
   *
   * @param {string} [cssSelector=#header] - The css selector matching the header container for the site.
   * @augments WDHComponent
   * @inheritDoc
   */
  function Header() {
    var _this;
    var cssSelector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '#header';
    _classCallCheck(this, Header);
    _this = _callSuper(this, Header, [cssSelector]);

    /**
     * The current header element
     * @type {Node}
     * @private
     */
    _this.header = null;

    /**
     * The burger menu element used to open the mobile menu
     * @type {Node}
     * @private
     */
    _this.burgerMenuElement = null;

    /**
     * The link element used to close the mobile menu
     * @type {Node}
     * @private
     */
    _this.closeBurgerMenuElement = null;
    return _this;
  }
  _inherits(Header, _WDHComponent);
  return _createClass(Header, [{
    key: "init",
    value: function init(component) {
      var _this2 = this;
      this.header = component;
      this.burgerMenuElement = this.getBurgerMenuElement();
      if (this.burgerMenuElement) {
        this.createBurgerMenuMarkup();
        this.enableBurgerMenuClick(function (event) {
          event.preventDefault();
          _this2.openBurgerMenu();
        });
      }
      this.closeBurgerMenuElement = this.getCloseBurgerMenuElement();
      if (this.closeBurgerMenuElement) {
        this.enableCloseBurgerMenuClick(function (event) {
          event.preventDefault();
          _this2.closeBurgerMenu();
        });
      }
      this.unhideComponents();
    }

    /**
     * Searches the header container for an element with the class .burger-menu
     * @returns {(Node|null)}
     */
  }, {
    key: "getBurgerMenuElement",
    value: function getBurgerMenuElement() {
      var elementList = this.getNodesFromSelector('.burger-menu .component-content', this.header);
      if (elementList.length > 0) {
        var element = elementList[0];
        return element;
      }
      return null;
    }

    /**
     * Creates the three line markup for the burgerMenuElement.
     */
  }, {
    key: "createBurgerMenuMarkup",
    value: function createBurgerMenuMarkup() {
      this.burgerMenuElement.innerHTML = '<span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>';
    }

    /**
     * Adds callback as the click event listener to the burgerMenuElement
     * @param callback - The function to trigger on click on the burgerMenuElement
     */
  }, {
    key: "enableBurgerMenuClick",
    value: function enableBurgerMenuClick(callback) {
      this.burgerMenuElement.addEventListener('click', callback);
    }

    /**
     * Opens the mobile menu by adding the class .mobile-open to the header container.
     */
  }, {
    key: "openBurgerMenu",
    value: function openBurgerMenu() {
      this.header.classList.add('mobile-open');
    }

    /**
     * Searches the header container for an element with the class .burger-menu-open
     * @returns {(Node|null)}
     */
  }, {
    key: "getCloseBurgerMenuElement",
    value: function getCloseBurgerMenuElement() {
      var elementList = this.getNodesFromSelector('.burger-menu-open', this.header);
      if (elementList.length > 0) {
        return elementList[0];
      }
      return null;
    }

    /**
     * Adds callback as the click event listener to the closeBurgerMenuElement
     * @param callback - The functio to trigger on click on the closeBurgerMenuElement
     */
  }, {
    key: "enableCloseBurgerMenuClick",
    value: function enableCloseBurgerMenuClick(callback) {
      this.closeBurgerMenuElement.addEventListener('click', callback);
    }

    /**
     * Closes the mobile menu by removing the class .mobile-open from the header container.
     */
  }, {
    key: "closeBurgerMenu",
    value: function closeBurgerMenu() {
      this.header.classList.remove('mobile-open');
    }

    /**
     * Iterates all the components in the header container and adds the platform life cycle
     * classes .component-ready and .animate that makes the components visible.
     * Also adds the .animate class to the header container to make it visible.
     */
  }, {
    key: "unhideComponents",
    value: function unhideComponents() {
      var subComponents = this.getNodesFromSelector('.component', this.header);
      subComponents.forEach(function (subComponent) {
        subComponent.classList.add('component-ready');
        subComponent.classList.add('animate');
      });
      this.header.classList.add('animate');
    }
  }]);
}(WDHComponent);
var h = new Header();
h.run();